import type { MediaBreakpoints } from "../types/breakpoints.types";

export const deviceSizes = {
	mobile: 646,
	tablet: 1023,
	laptop: 1399,
	desktop: 1600,
};

export const sizes: MediaBreakpoints = {
	mobile: "375px",
	mobileLandscape: "646px",
	tablet: "769px",
	tabletLandscape: "1024px",
	laptop: "1399px",
	desktop: "1600px",
};

const mediaBreakpoints: MediaBreakpoints = {
	mobile: `(min-width: ${sizes.mobile})`,
	mobileLandscape: `(min-width: ${sizes.mobileLandscape})`,
	tablet: `(min-width: ${sizes.tablet})`,
	tabletLandscape: `(min-width: ${sizes.tabletLandscape})`,
	laptop: `(min-width: ${sizes.laptop})`,
	desktop: `(min-width: ${sizes.desktop})`,
};

export const getPixelWidth = (media: keyof MediaBreakpoints): number => {
	return parseInt(sizes[media], 10);
};

export default mediaBreakpoints;
